import CitySEOHead from "@/components/feature/CitySEOHead";
import DaytonaHeroSection from "./components/HeroSection";
import DaytonaStickyNav from "./components/StickyNav";
import DaytonaProcessingTimeSection from "./components/ProcessingTimeSection";
import DaytonaServicesSection from "./components/ServicesSection";
import DaytonaLocalAreaSection, { landmarks } from "./components/LocalAreaSection";
import DaytonaTestimonialsSection from "./components/TestimonialsSection";
import DaytonaComparisonSection from "./components/ComparisonSection";
import DaytonaAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DaytonaMistakesSection from "./components/MistakesSection";
import DaytonaHowItWorksSection from "./components/HowItWorksSection";
import DaytonaFAQSection, { faqs } from "./components/FAQSection";
import DaytonaHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DaytonaFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Daytona Beach, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Daytona Beach, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Volusia County, Bike Week visitors, spring break travelers, and coastal Central Florida travelers needing urgent passport help.";

const areaServedList = [
  { "@type": "City", name: "Daytona Beach" },
  { "@type": "City", name: "Daytona Beach Shores" },
  { "@type": "City", name: "Port Orange" },
  { "@type": "City", name: "Ormond Beach" },
  { "@type": "City", name: "Holly Hill" },
  { "@type": "City", name: "Ponce Inlet" },
  { "@type": "City", name: "New Smyrna Beach" },
  { "@type": "AdministrativeArea", name: "Volusia County" },
];

const serviceAreaDesc = "Fast Passport Center is a registered U.S. Department of State passport courier serving Daytona Beach, Port Orange, Ormond Beach, and Volusia County with expedited passport processing as fast as 24 hours. A+ BBB rated.";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DaytonaBeachPage() {
  return (
    <>
      <CitySEOHead
        city="Daytona Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cities/daytona-beach"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Daytona Beach, Florida"
        geoPosition="29.2108;-81.0228"
        keywords="expedited passport Daytona Beach, emergency passport Daytona Beach FL, same day passport Daytona Beach, fast passport Florida, passport renewal Daytona Beach, Volusia County passport courier"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Florida"
        statePageRoute="/states/florida"
        hasPhysicalOffice
        lastModified="2026-06-09"
        areaServedList={areaServedList}
        serviceAreaDesc={serviceAreaDesc}
        landmarks={landmarks}
      />
      <div className="font-sans">
        <DaytonaHeroSection />
        <DaytonaStickyNav />
        <DaytonaProcessingTimeSection />
        <DaytonaLocalAreaSection />
        <DaytonaServicesSection />
        <DaytonaTestimonialsSection />
        <DaytonaAcceptanceFacilitiesSection />
        <DaytonaComparisonSection />
        <DaytonaMistakesSection />
        <DaytonaHowItWorksSection />
        <DaytonaFAQSection />
        <DaytonaHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/daytona-beach" state="FL" />
        <DaytonaFinalCTA />
      </div>
    </>
  );
}